import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "select",
    "template",
    "wordCountFields",
    "nameLabel",
    "choicesContainer",
    "choice"
  ]

  connect() {
    this.switchInputFields();
  }

  switchInputFields() {
    switch (this.selectTarget.value) {
      case "description_questionnaire":
        this.wordCountFieldsTarget.hidden = false;
        this.nameLabelTarget.hidden       = true;
        break;
      case "alternative_questionnaire":
      case "multiple_selection_questionnaire":
        this.wordCountFieldsTarget.hidden = true;
        this.nameLabelTarget.hidden       = false;
        break;
      case "attaching_file_questionnaire":
        this.wordCountFieldsTarget.hidden = true;
        this.nameLabelTarget.hidden       = true;
        break;
    }
  }

  removeChoice(event) {
    event.preventDefault();

    event.target.closest('.choice').hidden = true;
    event.target.closest('.choice').querySelector('input[type="text"]').value = '';
  }

  addChoice(event) {
    event.preventDefault();

    const visibleChoices = this.choiceTargets.filter(choice => !choice.hidden).length;

    if (visibleChoices >= 20) {
      alert(`選択肢は最大20個までしか追加できません。`);
      return;
    }

    const cloned          = this.templateTarget.content.cloneNode(true);
    const choiceNameInput = cloned.querySelector('input[type="text"]');

    // 複製したノードの input フィールドに、Rails の規約に則った形の属性値を付与する
    choiceNameInput.id   = `content_companions_edit_questionnaires_edit_attributes_questionnaire_choices_edits_attributes_${this.choiceTargets.length}_name`;
    choiceNameInput.name = `content_companions_edit[questionnaires_edit_attributes][questionnaire_choices_edits_attributes][${this.choiceTargets.length}][name]`;

    this.choicesContainerTarget.append(cloned);
  }
}
